import deepFreeze, { DeepReadonly } from "deep-freeze";

import data from "./data.json";
import list from "./list.json";

export type CountryData = {
  name: string;
  currencyCode: string | null;
  flag: string;
  phoneCode: string;
};

/**
 * TODO: Examine the performance implications of freezing this object.
 * If minimal, leave as-is and remove this comment.
 */

const frozenData: DeepReadonly<Record<string, CountryData>> = deepFreeze(data);
const frozenList = deepFreeze(list);

export { frozenData as countryData };
export { frozenList as countryList };
